// extracted by mini-css-extract-plugin
export default {"leave_mgt_table_wrapper":"LeaveManagentTable_leave_mgt_table_wrapper__RAfYl","table_header":"LeaveManagentTable_table_header__G3SLm"};